import el from "@cypherpotato/el";
import page from "page";
import { Icon } from "../../components/icon";
import { LoginLayout } from "./login-layout";

const supportUrl = "https://aivax.net/contact/";

export default function () {
    return LoginLayout(
        el("div.login-form",
            el("header.login-form-header",
                el("h1", "Account support"),
                el("p", "Choose how you want to recover access to your account.")
            ),
            el("div.login-help-options",
                el("a.login-help-option", {
                    href: "/login/help/recover",
                    onClick(event) {
                        event.preventDefault();
                        page("/login/help/recover");
                    }
                },
                    Icon("key-2-line"),
                    el("span",
                        el("strong", "Recover login key"),
                        el("small", "Email a one-time sign-in link and a link to reset your key.")
                    )
                ),
                el("a.login-help-option", {
                    href: supportUrl,
                    target: "_blank",
                    rel: "noreferrer"
                },
                    Icon("shield-keyhole-line"),
                    el("span",
                        el("strong", "Disable two-factor authentication"),
                        el("small", "Contact support if you no longer have your authenticator.")
                    )
                )
            ),
            el("div.login-register-row",
                el("a.app-link[href='/login']", "Back to sign in", {
                    onClick(event) {
                        event.preventDefault();
                        page("/login");
                    }
                })
            )
        )
    );
}
